/**
 * SecurityNote — the data-handling / security posture, in the exhibit system.
 * Four controls as ruled ExhibitCells (no icon chips), the honest SOC 2 line as
 * the section's provenance. Every claim is grounded (hash-chained audit ledger,
 * HTTPS/HSTS, per-firm org-scoping, no training on customer data). Compliance is
 * framed honestly — "architected for" + "on the roadmap", NOT certified. Atoms:
 * eyebrow only (no figure here; don't manufacture one).
 */

import { ExhibitCell, Provenance, SectionHeader } from './sectionPrimitives';

const CONTROLS: Array<{ title: string; body: string }> = [
  {
    title: 'Tamper-evident audit ledger',
    body: 'Every figure is recorded in a hash-chained ledger — any change breaks the chain and is detected.',
  },
  {
    title: 'Encrypted in transit',
    body: 'All traffic is served over HTTPS end to end, with HSTS enforced.',
  },
  {
    title: 'Isolated per firm',
    body: 'Role-based access — your case files are walled off from every other firm on the platform.',
  },
  {
    title: 'Never used to train AI',
    body: 'Your client data is never used to train language models.',
  },
];

export default function SecurityNote() {
  return (
    <section id="security" className="scroll-mt-24 border-t border-hairline">
      <div className="mx-auto max-w-[1400px] px-5 py-16 sm:px-8 lg:px-12 lg:py-24">
        <SectionHeader
          eyebrow="Security & data handling"
          title="Built on a forensic data spine"
          lede="Attorneys and CPAs upload privileged client financials. The platform was built from the first commit to hold them the way a forensic record has to be held."
        />

        <div className="mt-12 grid gap-8 md:grid-cols-2 lg:grid-cols-4">
          {CONTROLS.map((c, i) => (
            <ExhibitCell key={c.title} index={String(i + 1).padStart(2, '0')} title={c.title} body={c.body} />
          ))}
        </div>

        <Provenance note="Architected for SOC 2 from day one — formal certification on the roadmap" />
      </div>
    </section>
  );
}
